// @flow
import React, { createContext, useReducer } from 'react';
import { getDefaultTime } from './components/helpers';

export const actionTypes = {
  // Update actions
  UPDATE_STARTING_POINT: 'UPDATE_STARTING_POINT',
  UPDATE_ENDING_POINT: 'UPDATE_ENDING_POINT',
  UPDATE_DEPARTURE_TIME: 'UPDATE_DEPARTURE_TIME',
  UPDATE_TRAVEL_DIRECTION: 'UPDATE_TRAVEL_DIRECTION',
  UPDATE_FILTERED_TRAINS: 'UPDATE_FILTERED_TRAINS',
  SET_LOADING: 'SET_LOADING',

  // Fetch actions
  FETCH_TRAINS_FROM_NARITA: 'FETCH_TRAINS_FROM_NARITA',
  FETCH_TRAINS_TO_NARITA: 'FETCH_TRAINS_TO_NARITA',

  // Other
  RESET_SEARCH: 'RESET_SEARCH',
};

const filterTrains = (state: any) => {
  const fromNarita = state.isInboundTrain;
  const trainData: Array<Object> = fromNarita
    ? [...state.trainsFromNarita]
    : [...state.trainsToNarita];
  const referenceStation: string = fromNarita
    ? state.endingPoint
    : state.startingPoint;

  return trainData.filter((train: Object) => {
    const hasStop = train.stops.find(
      (stop: Object) => stop.station === referenceStation,
    );

    const startingStation = train.stops.find(
      (stop: Object) => stop.station === state.startingPoint,
    );

    return (
      hasStop && startingStation && startingStation.time >= state.departureTime
    );
  });
};

const trainsReducer = (state: any, action: Object) => {
  switch (action.type) {
    case actionTypes.UPDATE_STARTING_POINT:
      return {
        ...state,
        startingPoint: action.payload,
      };
    case actionTypes.UPDATE_ENDING_POINT:
      return {
        ...state,
        endingPoint: action.payload,
      };
    case actionTypes.UPDATE_DEPARTURE_TIME:
      return {
        ...state,
        departureTime: action.payload,
      };
    case actionTypes.UPDATE_TRAVEL_DIRECTION:
      return {
        ...state,
        isInboundTrain: !state.isInboundTrain,
        startingPoint: state.endingPoint,
        endingPoint: state.startingPoint,
      };
    case actionTypes.UPDATE_FILTERED_TRAINS:
      return {
        ...state,
        filteredTrains: filterTrains(state),
      };
    case actionTypes.FETCH_TRAINS_FROM_NARITA:
      return {
        ...state,
        trainsFromNarita: action.payload,
      };
    case actionTypes.FETCH_TRAINS_TO_NARITA:
      return {
        ...state,
        trainsToNarita: action.payload,
      };
    case actionTypes.RESET_SEARCH:
      return {
        ...state,
        isInboundTrain: true,
        startingPoint: 'narita_airport_terminal_1',
        endingPoint: 'tokyo',
        departureTime: getDefaultTime(),
      };
    case actionTypes.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
};

interface InitialState {
  startingPoint: string;
  endingPoint: string;
  departureTime: string;
  isInboundTrain: boolean;
  trainsFromNarita: Array<Object>;
  trainsToNarita: Array<Object>;
  filteredTrains: Array<Object>;
  isLoading: boolean;
}

const initialState: InitialState = {
  startingPoint: 'narita_airport_terminal_1',
  endingPoint: 'tokyo',
  departureTime: getDefaultTime(),
  isInboundTrain: true,
  trainsFromNarita: [],
  trainsToNarita: [],
  filteredTrains: [],
  isLoading: true,
};

// $FlowFixMe
const TrainsContext = createContext(initialState);

function TrainsProvider(props: any) {
  const [state, dispatch] = useReducer(trainsReducer, initialState);

  return (
    <TrainsContext.Provider value={{ state, dispatch }}>
      {props.children}
    </TrainsContext.Provider>
  );
}
export { TrainsContext, TrainsProvider };
